.button-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: fit-content;
    border-radius: 8px;
    border: 1px solid var(--ai-purple-pink-lt);
    background: var(--ai-purple-pink-xlt);
    padding: 7px 12px;
    gap: 6px;
    transition: background 200ms ease;
}

.button-container:hover {
    background: var(--ai-purple-pink-lt);
}

.button-container:focus {
    background: var(--ai-purple-pink-lt);
}
